import React, { Fragment } from 'react'
import estilos from './Documentacion.module.css'
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';

import BotonVerArchivosComponent from './BotonesComponent/BotonVerArchivosComponent';
import BotonHistorialComponent from './BotonesComponent/BotonHistorialComponent';
import BotonSustituirComponent from './BotonesComponent/BotonSustituirComponent';
import BotonDocumentoValidoComponent from './BotonesComponent/BotonDocumentoValidoComponent';
import { obtenerTodoHistorialCliente } from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';

function DocumentacionPrediosComponent(props) {
    let detalleCliente = props?.detalle
    const fechaHoy = moment().format('YYYY-MM-DD')
    const fc01ConMap = useSelector(store => store.ModuloConsulta.fc01ConMap)
    const dispatch = useDispatch()
    const usuarioCompleto = useSelector(store => store.Usuario.user)
    let rowsDocumentacionPredios = []

    for (const datos in detalleCliente.prediocliente) {
        if (rowsDocumentacionPredios.includes(detalleCliente?.prediocliente?.[datos]?.nombreparaje) == false) {
            rowsDocumentacionPredios.push({ id: uuidv4(), nameDoc: (detalleCliente?.prediocliente?.[datos]?.nombreparaje).toUpperCase() })
        }
        for (const i in detalleCliente.prediocliente[datos].archivospredioscliente) {

            const nameId = detalleCliente.prediocliente[datos].archivospredioscliente[i].nameid
            let alertaFechaVencimiento = ''
            let diasFaltantesVencimiento
            let nameDoc = ''
            let quitarVigencia = false

            if ((nameId).includes('COPIAESC')) nameDoc = 'Copia de escritura'
            else if ((nameId).includes('CONSPOS')) nameDoc = 'Constancia de posesión'
            else if ((nameId).includes('CONARREN')) nameDoc = 'Contrato de arrendamiento'
            else if ((nameId).includes('IOVARREN')) nameDoc = 'Identificación oficial vigente de arrendador'
            else if ((nameId).includes('IOVCOMPR')) nameDoc = 'Identificación oficial vigente de comprador'
            else if ((nameId).includes('CONCOMPR')) nameDoc = 'Contrato de compraventa'
            else if ((nameId).includes('CONCOMODA')) nameDoc = 'Contrato de comodato'
            else if ((nameId).includes('IOVCOMTE')) nameDoc = 'Identificación oficial vigente de comodante'
            else if ((nameId).includes('IOVCOMRIO')) nameDoc = 'Identificación oficial vigente de comodatario'

            if (nameId.includes('COPIAESC') || nameId.includes('CONSPOS') || nameId.includes('CONCOMPR')) quitarVigencia = true

            if (nameDoc.length > 0) {

                if (detalleCliente?.prediocliente?.[datos]?.archivospredioscliente?.[i]?.fechafin !== null) {

                    diasFaltantesVencimiento = moment(detalleCliente?.prediocliente?.[datos]?.archivospredioscliente?.[i]?.fechafin.substring(0, 10)).diff(moment(fechaHoy), 'days')

                    if (diasFaltantesVencimiento > 5) {
                        alertaFechaVencimiento = 'verde'
                    } else if (diasFaltantesVencimiento > 0 && diasFaltantesVencimiento < 6) {
                        alertaFechaVencimiento = 'amarillo'
                    } else if (diasFaltantesVencimiento == 0 || diasFaltantesVencimiento < 0) {
                        alertaFechaVencimiento = 'rojo'
                    }
                } else {
                    alertaFechaVencimiento = 'gris'
                }

                rowsDocumentacionPredios.push({
                    id: uuidv4(),
                    observacion: detalleCliente?.prediocliente?.[datos]?.archivospredioscliente?.[i]?.observaciones,
                    fechaInicio: detalleCliente?.prediocliente?.[datos]?.archivospredioscliente?.[i]?.fechainicio !== null ? detalleCliente?.prediocliente?.[datos]?.archivospredioscliente?.[i]?.fechainicio.substring(0, 10) : '---',
                    fechaTermino: detalleCliente?.prediocliente?.[datos]?.archivospredioscliente?.[i]?.fechafin !== null ? detalleCliente?.prediocliente?.[datos]?.archivospredioscliente?.[i]?.fechafin.substring(0, 10) : '---',
                    estatus: detalleCliente?.prediocliente?.[datos]?.archivospredioscliente?.[i]?.estatus !== null ? detalleCliente?.prediocliente?.[datos]?.archivospredioscliente?.[i]?.estatus : 'Agregar',
                    tabla: 'archivospredioscliente',
                    nombreId: 'idpredio',
                    idSolicitud: detalleCliente?.prediocliente?.[datos]?.archivospredioscliente?.[i]?.idpredio,
                    nameid: nameId, nameDoc: nameDoc, /* + ' del paraje: ' + detalleCliente?.prediocliente?.[datos]?.nombreparaje, */
                    idAnexo: detalleCliente?.prediocliente?.[datos]?.archivospredioscliente?.[i]?.idarchivospredio,
                    colorAlertaFecha: alertaFechaVencimiento, quitarVigencia: quitarVigencia,
                    isDocumentoValido: detalleCliente?.prediocliente?.[datos]?.archivospredioscliente?.[i]?.isdocumentovalido
                })
            }
        }

    }
    const columnsDocumentacion = [
        {
            field: 'documentoValido', headerName: '', headerAlign: 'center', width: 40, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {params.row.tabla &&
                        <Fragment>
                            <BotonDocumentoValidoComponent data={params.row} idcliente={detalleCliente.idcliente} />
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'nameDoc', headerName: '', headerAlign: 'center', width: 430, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {params.row.tabla ?
                        <div style={{ width: '100%', textAlign: 'left' }}>
                            <label>{`${params.row.nameDoc}`}</label>
                        </div>
                        :
                        <div style={{ width: '100%', padding: '3%' }}>
                            <label className={`${estilos.divisionDocumentacion}`}>{`${params.row.nameDoc}`}</label>
                        </div>
                    }
                </Fragment>
            )
        },
        {
            field: 'fechaTermino', headerName: '', headerAlign: 'center', width: 140, sortable: false,
            renderCell: (params) => (
                <Fragment>
                    {params.row.tabla && params.row.quitarVigencia == true &&
                        <Fragment>
                            <label> Sin vigencia </label>
                        </Fragment>
                    }
                    {params.row.tabla && params.row.quitarVigencia == false &&
                        <Fragment>
                            <label> {`${params.row.fechaTermino}`} </label>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'archivo', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <Fragment>
                            <Tooltip title="Ver documento"><BotonVerArchivosComponent tabla={params.row?.tabla} nombreId={params.row?.nombreId} idSolicitud={params.row?.idSolicitud} nameid={params.row?.nameid} /></Tooltip>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'historial', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <Fragment>
                            <Tooltip title="Ver historial de cambios"><IconButton size="large" onClick={() => { handleModalHistorial(params) }}> <HistoryRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'estatusfecha', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) => (
                <Fragment>
                    {params.row.tabla && params.row.colorAlertaFecha == 'verde' && params.row.quitarVigencia == false &&
                        <Fragment>
                            <Tooltip title="Vigente"><IconButton size="large"> <CheckCircleOutlineRoundedIcon fontSize="inherit" style={{ fill: '#8ABE3E' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                    {params.row.tabla && params.row.colorAlertaFecha == 'amarillo' && params.row.quitarVigencia == false &&
                        <Fragment>
                            <Tooltip title="Próximo a vencer"><IconButton size="large"> <ErrorOutlineRoundedIcon fontSize="inherit" style={{ fill: '#F4D35E' }} /> </IconButton></Tooltip>                        </Fragment>
                    }
                    {params.row.tabla && params.row.colorAlertaFecha == 'rojo' && params.row.quitarVigencia == false &&
                        <Fragment>
                            <Tooltip title="Vencido"><IconButton size="large"> <ErrorOutlineRoundedIcon fontSize="inherit" style={{ fill: '#DC3545' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                    {/*params.row.tabla && params.row.colorAlertaFecha == 'gris' &&
                        <Fragment>
                            <Tooltip title="Sin fechas asignadas"><IconButton size="large"> <BlockRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                        </Fragment>
                    */}
                </Fragment>
            )
        },
        {
            field: 'accion', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) => (
                <Fragment>
                    {params.row.tabla &&
                        <Fragment>
                            {(usuarioCompleto?.[0]?.tipousuario?.idtipousuario != 2 && usuarioCompleto?.[0]?.tipousuario?.idtipousuario != 1) &&
                                <Tooltip title="Sustituir archivo"><IconButton size="large" onClick={() => sustituir(params)} > <FileUploadRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                            }
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'observacion', headerName: '', headerAlign: 'center', width: 300, sortable: false
        },
    ]

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState([]);
    const [archivo, setArchivo] = React.useState('');

    const handleModalHistorial = async (params) => {
        let data = {}
        if (params.row.tabla === "archivosgeneralescliente") {
            data = { idSolicitud: params.row.idSolicitud, tabla: params.row.tabla }
        } else {
            data = { idSolicitud: params.row.idAnexo, tabla: params.row.tabla }
        }
        let datosObtenidos = await dispatch(obtenerTodoHistorialCliente(data))
        setDataHistorial(datosObtenidos?.payload)
        setArchivo(params?.row?.nameDoc)
        setOpenModalHistorial(true)
    }
    const [openModalSustituir, setOpenModalSustituir] = React.useState(false);
    const [dataSustituir, setDataSustituir] = React.useState([]);

    const sustituir = async (params) => {
        setDataSustituir(params.row)
        setOpenModalSustituir(true)
    }

    return (
        <Fragment >
            <div style={{ fontFamily: 'Montserrat', height: '700px' }}>
                {detalleCliente.prediocliente.length > 0 &&
                    <div style={{ margin: 0, padding: 0 }}>
                        <h5 style={{ textAlign: 'center', fontWeight: 'bold', color: '#7D9A47' }} >Documentación de predios.</h5>
                        <Box sx={{ height: '700px', width: '100%', mt: 2 }}>
                            <DataGrid
                                rows={rowsDocumentacionPredios}
                                columns={columnsDocumentacion}
                                rowsPerPageOptions={[50]}
                                headerHeight={0}
                                getRowHeight={() => 'auto'}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    backgroundColor: 'white',
                                    fontFamily: 'Montserrat',
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#4399A4',
                                        color: 'white',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 'bold',
                                        height: '5px'
                                    },
                                    '& .MuiDataGrid-cell': {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    },
                                }}
                            />
                        </Box>
                    </div>
                }
                {detalleCliente.prediocliente.length == 0 &&
                    <div style={{ height: '700px', margin: 0, padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h5 style={{ fontWeight: 'bold', color: '#7D9A47' }} >No existe documentación registrada.</h5>
                    </div>
                }
                {openModalHistorial && <BotonHistorialComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} archivo={archivo} />}
                {openModalSustituir && <BotonSustituirComponent setOpenModalSustituir={setOpenModalSustituir} data={dataSustituir} idcliente={detalleCliente?.idcliente} />}
            </div>
        </Fragment>
    )

}

export default DocumentacionPrediosComponent